export const EXPIRATION_DATE = "dates.expiration";
export const DATE_LISTED = "dates.date_listed_milestone";
export const CLOSE_DATE = "dates.close_date_milestone";
export const MUTUAL_ACCEPTANCE_DATE = "dates.mutual_acceptance_date_milestone";
